export function Commerce() {

  (function ($, Drupal, drupalSettings) {

      $(document).ajaxSend(function(event, jqxhr, settings) {

      });

      Drupal.behaviors.noahsCommerceCart = {
        attach: function (context) {
          // Delegar clicks para toggle.
          $(context).off('click.noahsCartToggle').on('click.noahsCartToggle', '.noahs-commerce-cart__toggle', function (e) {

            e.preventDefault();
            const $btn = $(this);
            const $wrap = $btn.closest('.noahs-commerce-cart');
            const expanded = $btn.attr('aria-expanded') === 'true';

            // Carga diferida del sidebar en la primera apertura
            if (!expanded && $wrap.length && !$wrap.data('loaded')) {
              const url = drupalSettings?.noahs_page_builder_pro?.cart_sidebar_url;
              if (url) {
                $.get(url).done(function (html) {
                  $('body').append(html);
                }).always(function(){

                });
              }
            } 
            $btn.attr('aria-expanded', !expanded);
          });
          // Delegar eliminación (placeholder para AJAX futuro).
          $(context).off('click.noahsCartRemove').on('click.noahsCartRemove', '.noahs-commerce-cart-sidebar__remove', function (e) {
            e.preventDefault();
            console.log('Eliminar item del carrito (AJAX pendiente)');
            const $item = $(this).closest('.noahs-commerce-cart-sidebar__item');
            const orderItemId = $item.data('order-item-id');
            const pattern = drupalSettings?.noahs_page_builder_pro?.cart_remove_url_pattern;
            if (!pattern || !orderItemId) return;
            const url = pattern.replace(/0$/, orderItemId); // patrón termina en /0
            $item.addClass('is-removing');
            $.ajax({
              url,
              method: 'POST',
              dataType: 'json'
            }).done(function (resp) {
              if (resp.status === 'ok') {
                // Reemplazar sidebar completo.
                const $sidebar = $('.noahs-commerce-cart-sidebar');
                if (resp.html) {
                  $sidebar.replaceWith(resp.html);
                }
                // Actualizar contador y total en el icono.
                $('.noahs-commerce-cart-sidebar__summary__count, .cart-block--summary__count').text(resp.count);
                $('.cart-block--summary__total').text(resp.total_price);
              }
            }).fail(function(){
              $item.removeClass('is-removing');
            });
          });
          $(document).on('click', '.noahs-commerce-cart-sidebar__close', function (e) {
            e.preventDefault();
            $('.noahs-commerce-cart__toggle').attr('aria-expanded', 'false');
            $('.noahs-commerce-cart-sidebar').remove();
          });
        } 
      };

      // Fallback document ready (si behaviors no cargan aún).
      $(document).ready(function(){ Drupal.behaviors.noahsCommerceCart.attach(document); });

      // El sidebar ya devuelve checkout_url, no requiere ajustes adicionales aquí.

  })(jQuery, Drupal, drupalSettings);

}
